<template lang="pug">
.room-wrapper
  .room-container(:class="getBackgroundCss(roomData)")
    .d-flex.justify-content-between.align-items-center
      div#v-step-5
        div
          | {{ $t('ui.pool') }}:
          span.amount.ml-1 {{ $numeral(roomData.pool).format("0,0") }}
          span.tournament-jackpot.ml-2(v-if="roomData.jackpot > 0")
            i.fad.fa-chevron-double-up
            span {{ $numeral(roomData.jackpot * 100).format("0,0") }}%
        div {{ $t('ui.room') }}: {{ roomData.room_id }}
      .d-flex
        template(v-if="canJoin")
          button.status.room_0.mr-2(@click="debouncePush" :disabled="loading.getMatch")
            template(v-if="loading.getMatch")
              i.fad.fa-spinner-third.fa-spin
            template(v-else)
              i.fad.fa-redo.mr-2
              span {{ counter }}s
        template(v-else)
          button.status.room_0.mr-2(@click="debouncePush" :disabled="loading.getBetResultList")
            template(v-if="loading.getBetResultList")
              i.fad.fa-spinner-third.fa-spin
            template(v-else)
              i.fad.fa-redo.mr-2
              span {{ counter }}s
    a(v-if="canJoin && (roomData.room_count < roomData.room_limit)")
      .join-now-wrapper
        .player
          i.fad.fa-users
          span.mx-1 {{ $t('ui.players') }}:
          span {{ roomData.room_count }} / {{ roomData.room_limit }}
        div(v-if="roomData.room_rate > 0")
          | {{ $t('ui.entry_fee') }}:
          span.amount.mr-1.ml-1 {{ $numeral(roomData.room_rate).format("0,0") }}
          small(style="color: #08ff00cc;") ( {{ currencyCode }} {{ $numeral(roomData.room_rate / roomData.rate).format("0,0.00")  }} )
        div(v-else)
          | {{ $t('ui.free_room') }}
        .trophy(v-if="roomData.room_status == 3 && (roomData.position != null) && ([1,2,3].includes(roomData.position))")
          img.img-fluid(:src="'/images/tournament/trophy' + roomData.position.toString() + '.svg'")
    a(v-else)
      .join-now-wrapper
        .player(v-if="roomData.room_count < roomData.room_limit")
          i.fad.fa-users
          span.mx-1 {{ $t('ui.players') }}:
          span {{ roomData.room_count }} / {{ roomData.room_limit }}
        .player(v-else) {{ $t('message.room_full') }}
        div(v-if="canBet && roomData.room_join === 1")
          template(v-if="roomData.end_time")
            span.mr-2 {{ $t('ui.last_betting_time') }}:
            span.text-success.font-weight-bold {{ getCountDown(roomData.end_time) }}
        div(v-else)
          span.text-success.font-weight-bold(v-if="roomData.room_status") {{ $t('m.ROOM_' + roomData.room_status) }}
  .room-info-wrapper
    .user-total-points
      .title {{ $t("ui.total_points") }}
      .points {{ roomData.total_points != null ? $numeral(roomData.total_points).format("0,0.00") : '-' }}
    .d-flex.justify-content-between
      a.tab-button#v-step-4(:class="listMode == 0 ? 'active' : ''" @click="listMode = 0") {{ $t("ui.details") }}
      a.tab-button(:class="listMode == 1 ? 'active' : ''" @click="listMode = 1")
        span(v-if="canBet") {{ $t("ui.matches") }}
        span(v-else) {{ $t("ui.bet_list") }}
      a.tab-button#v-step-6(:class="listMode == 2 ? 'active' : ''" @click="listMode = 2")
        span(v-if="isRanking") {{ $t("ui.ranking") }}
        span(v-else) {{ $t("ui.players") }}
      a.tab-button(ref="mybetsResult" :class="listMode == 3 ? 'active' : ''" @click="listMode = 3")
        span(v-if="[2,3].includes(roomData.room_status)") {{ $t("ui.result") }}
        span(v-else) {{ $t("ui.my_bets") }}
  //- details
  template(v-if="listMode == 0")
    roomGameDetails(:roomData="roomData")

  //- matches and betlist
  template(v-if="listMode == 1")
    template(v-if="canBet")
      template(v-if="(roomData.total_match != null) && (roomData.total_match > 0)")
        template(v-if="leagueList.hasOwnProperty(roomData.room_id) && canBet")
          .room-match-wrapper.collapse.show(:id="'room-' + roomData.room_id")
            .room-league-wrapper(v-for="ln in leagueList[roomData.room_id]")
              .select-league-box.room-league.collapsed(
                @click="selectedLeague = '#heading-' + roomData.room_id + '-league-' + ln.league_id"
                data-toggle="collapse"
                :data-target="'#room-' + roomData.room_id + '-league-' + ln.league_id" 
                aria-expanded='false'
                :aria-controls="'room-' + roomData.room_id + '-league-' + ln.league_id"
              )
                .tournament-league-club
                  img(v-if="ln.logo" :src="getLogo('league', ln.logo)")
                .tournament-text.flex-fill 
                  | {{ getName('name_', ln) }}
                .tournament-arrow
                  i.fad.ml-2.fa-chevron-up
              .room-matches.collapse(:id="'room-' + roomData.room_id + '-league-' + ln.league_id")
                template(v-if="matchList.hasOwnProperty(roomData.room_id)")
                  template(v-if="matchList[roomData.room_id].hasOwnProperty(ln.league_id)")
                    template(v-for="match in matchList[roomData.room_id][ln.league_id]")
                      template(v-if="odds[match.match_id] && odds[match.match_id]['hdp'] && odds[match.match_id]['hdp'][9] != 0 && odds[match.match_id]['hdp'][10] != 0 && odds[match.match_id]['hdp'][9] != '' && odds[match.match_id]['hdp'][10] != ''")
                        .room-team-details
                          .room-team-details-left
                            //- .room-team-logo
                            //-   img(v-if="match.home_logo" :src="getLogo('team', match.home_logo)")
                            //-   span(v-else) &nbsp;
                            div(:class="{ 'tournament-home': odds[match.match_id]['hdp'][7] == 1 }") {{ getName('home_name_', match) }}
                          .room-team-date
                            div {{ getMatchDate(match.match_time) }}
                            div {{ getMatchTime(match.match_time) }}
                          .room-team-details-right
                            //- .room-team-logo
                            //-   img(v-if="match.away_logo" :src="getLogo('team', match.away_logo)")
                            //-   span(v-else) &nbsp;
                            div(:class="{ 'tournament-home': odds[match.match_id]['hdp'][7] == 0 }") {{ getName('away_name_', match) }}
                      template(v-else)
                        .room-team-details
                          .room-team-details-left
                            //- .room-team-logo
                            //-   img(v-if="match.home_logo" :src="getLogo('team', match.home_logo)")
                            //-   span(v-else) &nbsp;
                            div {{ getName('home_name_', match) }}
                          .room-team-date
                            div {{ getMatchDate(match.match_time) }}
                            div {{ getMatchTime(match.match_time) }}
                          .room-team-details-right
                            //- .room-team-logo
                            //-   img(v-if="match.away_logo" :src="getLogo('team', match.away_logo)")
                            //-   span(v-else) &nbsp;
                            div {{ getName('away_name_', match) }}
                      template(v-if="canBet")
                        .room-odds-details
                          .room-odds-single
                            .match-bet-area-group
                              .match-bet-area-type
                                .match-bet-area-type-title {{ $tc("m.BT_HDP", 1) }}
                                .match-odd-area
                                  .match-odd-area-oddtype
                                    p.mb-0 {{ $t("m.ODD_Home") }}
                                    p.mb-0 {{ $t("m.ODD_Away") }}
                                  .match-odd-area-group
                                    template(v-if="odds[match.match_id] && odds[match.match_id]['hdp'] && odds[match.match_id]['hdp'][9] != 0 && odds[match.match_id]['hdp'][10] != 0 && odds[match.match_id]['hdp'][9] != '' && odds[match.match_id]['hdp'][10] != ''")
                                      roomOdds(:odds="odds[match.match_id]['hdp']" :idx="odds[match.match_id]['hdp'][7] == 1 ? '10' : '9'" :typ="oddsType" dataType="1" :roomData="roomData" :match="match" homeAway="1" mode="hdp")
                                    template(v-else)
                                      .odd-box
                                        .odd.lock
                                          i.fad.fa-lock-alt
                                    template(v-if="odds[match.match_id] && odds[match.match_id]['hdp'] && odds[match.match_id]['hdp'][9] != 0 && odds[match.match_id]['hdp'][10] != 0 && odds[match.match_id]['hdp'][9] != '' && odds[match.match_id]['hdp'][10] != ''")
                                      roomOdds(:odds="odds[match.match_id]['hdp']" :idx="odds[match.match_id]['hdp'][7] == 1 ? '9' : '10'" :typ="oddsType" dataType="1" :roomData="roomData" :match="match" homeAway="2" mode="hdp")
                                    template(v-else)
                                      .odd-box
                                        .odd.lock
                                          i.fad.fa-lock-alt
                            .match-bet-area-group
                              .match-bet-area-type
                                .match-bet-area-type-title {{ $tc("m.BT_OU", 1) }}
                                .match-odd-area
                                  .match-odd-area-oddtype
                                    p.mb-0 {{ $t("m.ODD_Over") }}
                                    p.mb-0 {{ $t("m.ODD_Under") }}
                                  .match-odd-area-group
                                    template(v-if="odds[match.match_id] && odds[match.match_id]['ou'] && odds[match.match_id]['ou'][11] != 0 && odds[match.match_id]['ou'][12] != 0 && odds[match.match_id]['ou'][11] != '' && odds[match.match_id]['ou'][12] != ''")
                                      roomOdds(:odds="odds[match.match_id]['ou']" :idx="odds[match.match_id]['ou'][7] == 1 ? '12' : '11'" :typ="oddsType" dataType="1" :roomData="roomData" :match="match" homeAway="1" mode="ou")
                                    template(v-else)
                                      .odd-box
                                        .odd.lock
                                          i.fad.fa-lock-alt
                                    template(v-if="odds[match.match_id] && odds[match.match_id]['ou'] && odds[match.match_id]['ou'][11] != 0 && odds[match.match_id]['ou'][12] != 0 && odds[match.match_id]['ou'][11] != '' && odds[match.match_id]['ou'][12] != ''")
                                      roomOdds(:odds="odds[match.match_id]['ou']" :idx="odds[match.match_id]['ou'][7] == 1 ? '11' : '12'" :typ="oddsType" dataType="1" :roomData="roomData" :match="match" homeAway="2" mode="ou")
                                    template(v-else)
                                      .odd-box
                                        .odd.lock
                                          i.fad.fa-lock-alt
                      template(v-else)
                        .room-odds-details
                          .room-odds-single
                            .match-bet-area-group
                              .match-bet-area-type
                                .match-bet-area-type-title {{ $tc("m.BT_HDP", 1) }}
                                .match-odd-area
                                  .match-odd-area-oddtype
                                    p.mb-0 {{ $t("m.ODD_Home") }}
                                    p.mb-0 {{ $t("m.ODD_Away") }}
                                  .match-odd-area-group
                                    .odd-box
                                      .odd.lock
                                        i.fad.fa-lock-alt
                                    .odd-box
                                      .odd.lock
                                        i.fad.fa-lock-alt
                            .match-bet-area-group
                              .match-bet-area-type
                                .match-bet-area-type-title {{ $tc("m.BT_OU", 1) }}
                                .match-odd-area
                                  .match-odd-area-oddtype
                                    p.mb-0 {{ $t("m.ODD_Over") }}
                                    p.mb-0 {{ $t("m.ODD_Under") }}
                                  .match-odd-area-group
                                    .odd-box
                                      .odd.lock
                                        i.fad.fa-lock-alt
                                    .odd-box
                                      .odd.lock
                                        i.fad.fa-lock-alt
          .match-wrapper(
            v-if="(roomData.total_match != null) && (roomData.total_match > 0) && canBet && (listMode === 1)"
            @click="getLeagueList(roomData.room_id)"
            data-toggle='collapse'
            :data-target="'#room-' + roomData.room_id"
            aria-expanded='false'
            :aria-controls="'room-' + roomData.room_id"
          ) {{ match_count }} / {{ roomData.total_match }} {{ $t('ui.matches') }}
        template(v-else)
          .room-match-wrapper.collapse.show
            .room-league-wrapper
              .select-league-box.room-league.d-flex.align-items-center.justify-content-center.p-2
                .fad.fa-spinner.fa-spin(style="line-height: 1; font-size: 14px; color: #888;")
    template(v-else)
      template(v-if="betResultList == 'undefined' || betResultList.length <= 0")
        .room-ranking-wrapper
          .user-betlist.d-flex.align-items-center.justify-content-center
            template(v-if="loading.getBetResultList")
              i.fad.fa-spinner-third.fa-spin
            template(v-else)
              .empty.text-center
                b {{ $t('message.no_information_available') }}
      template(v-else)
        template(v-for="(item, index) in betResultList")
          .room-ranking-wrapper
            .user-betlist
              .d-flex.justify-content-between
                .id.text-yellow {{ $t("ui.ref_no") }}: {{ item.bet_id }}
                .status {{ parseFloat(item.winlose) != 0 ? (parseFloat(item.winlose) < 0 ? $t("ui.lost") : $t("ui.won")) : $t("ui.draw") }} ({{ item.score }})
              .odds
                | {{ item.full_half }} - {{ item.goal }}
                span.text-red.mx-1 @
                | {{ item.odds_display }}
              .match-info
                .text-lightblue {{ item.league_name }}
                | {{ item.home_team_name }} -vs- {{ item.away_team_name }}
              .date.text-lightblue {{ $dayjs(item.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
              .d-flex.result
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.stake") }}
                  .amount {{ $numeral(item.bet_member).format("0,0") }}
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.winlose") }}
                  .amount(:class="{ 'text-danger': parseFloat(item.winlose) < 0 }") {{ $numeral(item.winlose).format("0,0") }}
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.points") }}
                  .amount(:class="{ 'text-danger': parseFloat(item.payout) < 0 }") {{ $numeral(item.payout).format("0,0") }}

  //- ranking
  template(v-if="listMode == 2")
    template(v-if="isRanking")
      roomGameRanking(:roomRank="roomRank" :participants="participants" :roomId="roomData.room_id" :roomStatus="roomData.room_status")
    template(v-else)
      roomGameParticipants(:participants="participants" :roomId="roomData.room_id")

  //- result
  template(v-if="listMode == 3")
    roomGameResult(:roomData="roomData")

  v-tour(name="tour2" :steps="tour.steps" :callbacks="tour.callbacks" :options="tour.options")
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";
import calc from "@/library/_calculation.js";
import sync2 from "@/library/_sync-match";
import xhrMatch from "@/library/_xhr-match";

const _INTERVAL = 300;

export default {
  components: {
    roomOdds: () => import("@/views/tournament/components/roomOdds.vue"),
    roomGameDetails: () => import("@/views/tournament/components/roomGameDetails.vue"),
    roomGameRanking: () => import("@/views/tournament/components/roomGameRanking.vue"),
    roomGameParticipants: () => import("@/views/tournament/components/roomGameParticipants.vue"),
    roomGameResult: () => import("@/views/tournament/components/roomGameResult.vue")
  },
  props: {
    roomId: {
      type: Number,
    }
  },
  data() {
    return {
      selectedLeague: null,
      roomData: {},
      listMode: 0,
      // selectedResult: null,
      debouncePop: null,
      handler: null,
      counter: _INTERVAL,
      last_betting_time: null,
      leagueList: {},
      matchList: {},
      matches: [],
      odds: {},
      loading: {
        getLeagueList: false,
        getMatchList: false,
        getMatch: false,
        getBetResultList: false,
        getRoomRank: false,
        getMemberBetList: false,
      },
      betList: [],
      betResultList: [],
      participants: [],
      roomRank: [],
      betResultListTotal: {
        odds_display: 0,
        turnover: 0,
        winlose: 0,
        payout: 0,
        status: null,
      },
      betMode: false,
      tour: {
        options: {
          labels: {
            buttonSkip: this.$t("message.button_skip"),
            buttonPrevious: this.$t("message.button_previous"),
            buttonNext: this.$t("message.button_next"),
            buttonStop: this.$t("message.button_stop")
          }
        },
        callbacks: {
          onStart: this.onStart,
          onPreviousStep: this.onPreviousStep,
          onNextStep: this.onNextStep,
          onSkip: this.onSkip,
          onFinish: this.onFinish,
          onStop: this.onStop,
        },
        steps: [
          {
            target: '#v-step-4',
            content: this.$t("message.tour_content_6")
          },
          {
            target: '#v-step-5',
            content: this.$t("message.tour_content_7")
          },
          {
            target: '#v-step-6',
            content: this.$t("message.tour_content_10")
          },
        ]
      },
    };
  },
  computed: {
    tour1() {
      return this.$store.state.layout.tour1;
    },
    isRanking() {
      return this.roomRank.length > 0;
    },
    canJoin() {
      return [0].includes(this.roomData.room_status) && this.roomData.room_join === 0;
    },
    canBet() {
      return [0, 1].includes(this.roomData.room_status);
    },
    oddsTypeLocale() {
      return config.oddsTypeLocale;
    },
    commType() {
      return "A";
    },
    oddsType() {
      return "DEC";
    },
    language() {
      return this.$store.getters.language;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    }
  },
  destroyed() {
    if (this.handler != null) {
      clearTimeout(this.handler);
    }
    EventBus.$off("roomGameRefresh", this.fromBetSlip);
  },
  mounted() {
    this.handleTimer();
    this.debouncePop = this.debounce(this.getData, 250);
    this.getData(true);

    EventBus.$on("roomGameRefresh", this.fromBetSlip);

    if (this.tour1 == false) {
      this.$tours['tour1'].stop();
      this.$tours['tour2'].start();
    }
  },
  methods: {
    onStart() {
    },
    onPreviousStep(currentStep) {
    },
    onNextStep(currentStep) {
    },
    onSkip() {
      this.$store.dispatch("layout/setTour1", true);
    },
    onFinish() {
      this.$store.dispatch("layout/setTour1", true);
    },
    onStop() {
      this.$store.dispatch("layout/setTour1", true);
    },
    getMatchDate(e) {
      var mdate = this.$dayjs(e).format("MM/DD");
      // if (["MMK", "MMO"].includes(this.currencyCode)) {
      //   mdate = this.$dayjs(e).subtract(90, "minute").format("MM/DD");
      // }

      switch (this.currencyCode) {
        case "MMK":
        case "MMO":
          mdate = this.$dayjs(e).subtract(90, "minute").format("MM/DD");
          break;
        case "NGN":
          mdate = this.$dayjs(e).subtract(420, "minute").format("MM/DD");
          break;
      }
      return mdate;
    },
    getMatchTime(e) {
      var mdate = this.$dayjs(e).format("hh:mm A");
      // if (["MMK", "MMO"].includes(this.currencyCode)) {
      //   mdate = this.$dayjs(e).subtract(90, "minute").format("hh:mm A");
      // }

      switch (this.currencyCode) {
        case "MMK":
        case "MMO":
          mdate = this.$dayjs(e).subtract(90, "minute").format("hh:mm A");
          break;
        case "NGN":
          mdate = this.$dayjs(e).subtract(420, "minute").format("hh:mm A");
          break;
      }
      return mdate;
    },
    fromBetSlip() {
      // this.getData();
      var elem = this.$refs.mybetsResult;
      elem.click();
    },
    getCountDown(e) {
      var endTime = this.$dayjs(e).subtract(1, 'minute').format("YYYY-MM-DDTHH:mm:ss")
      var difference = this.$dayjs.utc(endTime + "+0800").diff(this.$dayjs.utc());
      var days = Math.floor(difference / (1000 * 60 * 60 * 24));
      var hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      var minutes = Math.floor((difference / 1000 / 60) % 60);
      var seconds = Math.floor((difference / 1000) % 60);
      if (days < 0 || hours < 0 || minutes < 0 || seconds < 0) {
        return this.$t("ui.match_started");
      } else {
        if (days === 0) {
          if (hours === 0) {
            if (minutes === 0) {
              return seconds + "s";
            } else {
              return minutes + "m";
            }
          } else {
            return hours + "h " + minutes + "m";
          }
        } else {
          return days + "d " + hours + "h " + minutes + "m";
        }
      }
    },
    getBackgroundCss(roomData){
      let logo = roomData.league_logo
      let type = roomData.room_type
      let bg = ''

      if(logo && type != 2) {
        return logo.split('.')[0]
      } else {
        return bg
      }
    },
    formatOddsDisplay(odds, bet_type) {
      if (bet_type == "cs") return calc.fmcs(odds);
      else return calc.fmt(odds);
    },
    debouncePush() {
      if (this.debouncePop) {
        this.debouncePop();
        // EventBus.$emit("roomBetSlipRefresh");
      }
    },
    debounce(func, wait, immediate) {
      var timeout;

      return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    },
    getData(e) {
      this.getRoomInfo(e).then(() => {
        this.getBetResultList();
        this.getMemberBetList();
        this.getRoomRank();
        this.getLeagueList().then(
          () => {
            this.populateMatches().then(
              () => {
                this.counter = _INTERVAL;
                if (this.selectedLeague) {
                  if ($(this.selectedLeague).hasClass("collapsed")) {
                    $(this.selectedLeague).click();
                    $(this.selectedLeague).get(0).scrollIntoView();
                  }
                }
              },
              (err) => {
              }
            );
          },
          (err) => {
          }
        );
      });
    },
    handleTimer() {
      // this.counter = e;
      this.handler = setTimeout(() => {
        // minus counter and reset to 60 if counter is 0
        if (this.counter > 0) {
          this.counter--;
        } else {
          this.counter = _INTERVAL;
          this.getData();
          // EventBus.$emit("roomBetSlipRefresh");
        }
        this.handleTimer();
      }, 1000);
    },
    cancel() {
      this.$emit("room-leave");
    },
    getMatchList(e, f) {
      return new Promise((resolve, reject) => {
        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          room_id: e,
          league_id: f,
          page_number: 1,
          page_size: 100,
        };

        var feedback = {
          success: false,
          status: errors.session.invalidSession,
        };

        this.loading.getMatchList = true;
        service.getMatchList(config.tournamentUrl().roommatchlist, json).then(
          (result) => {
            this.loading.getMatchList = false;
            if (result) {
              feedback.success = result.success;
              feedback.status = result.status;
              if (result.success == true) {
                if (!this.matchList.hasOwnProperty(e)) {
                  this.$set(this.matchList, e, {});
                }
                this.$set(this.matchList[e], f, result.data.value);

                for (var i = 0; i < result.data.value.length; i++) {
                  this.matches.push(result.data.value[i].match_id);
                }
                resolve({ league_id: f, count: result.data.value.length });
              } else {
                this.$helpers.handleFeedback(feedback.status);
                resolve({ league_id: f, count: 0 });
              }
            } else {
              resolve({ league_id: f, count: 0 });
            }
          },
          (err) => {
            this.loading.getMatchList = false;
            feedback.success = false;
            feedback.status = errors.request.failed;
            this.$helpers.handleFeedback(err.status);
            resolve({ league_id: f, count: 0 });
          }
        );
      });
    },
    getLeagueList() {
      return new Promise((resolve, reject) => {
        if (![0, 1].includes(this.roomData.room_status)) {
          resolve();
        }

        var e = this.roomData.room_id;

        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          room_id: e,
          page_number: 1,
          page_size: 100,
        };

        var feedback = {
          success: false,
          status: errors.session.invalidSession,
        };

        this.loading.getLeagueList = true;
        service.getLeagueList(config.tournamentUrl().roomleaguelist, json).then(
          (result) => {
            this.loading.getLeagueList = false;
            if (result) {
              feedback.success = result.success;
              feedback.status = result.status;
              if (result.success == true) {
                var ln = result.data.value;
                var j = 0;
                var k = ln.length;
                var items = [];
                for (var i = 0; i < k; i++) {
                  var lid = ln[i].league_id;
                  var ret = false;
                  this.getMatchList(e, lid).then((res) => {
                    items.push(res);
                    j = j + 1;
                    if (j == k) {
                      setTimeout(() => {
                        this.populateMatches().then(() => {
                          var deleted = [];
                          var inserted_array = [];
                          // var inserted_object = {};
                          // var inserted_ids = [];

                          var mc = 0;
                          for (var i = 0; i < items.length; i++) {
                            mc += items[i].count;
                            if (items[i].count <= 0) {
                              deleted.push(items[i].league_id);
                            }
                          }
                          this.match_count = mc;
                          for (var i = 0; i < k; i++) {
                            if (!deleted.includes(ln[i].league_id)) {
                              // inserted_ids.push(ln[i].league_id);
                              inserted_array.push(ln[i]);
                              // inserted_object[ln[i].league_id] = ln[i];
                            }
                          }
                          this.$set(this.leagueList, e, inserted_array);
                        });
                      }, 100);
                    }
                  });
                }
              } else {
                this.$helpers.handleFeedback(feedback.status);
              }
            }

            resolve();
          },
          (err) => {
            console.log(err);
            this.loading.getLeagueList = false;
            feedback.success = false;
            feedback.status = errors.request.failed;
            this.$helpers.handleFeedback(err.status);

            resolve();
          }
        );
      });
    },
    getName(p, e) {
      var name = e[p + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "en"];
      }
      return name;
    },
    getLogo(p, e) {
      return config.flagPath + p + "/" + e;
    },
    getMatch(url, id, mid, mkt, bt, fn) {
      return new Promise((resolve, reject) => {
        if (mid != null && mid.length > 0) {
          var args = {
            account_id: this.$store.getters.accountId,
            session_token: this.$store.getters.sessionToken,
            arguments: [this.language, bt, mkt],
            ids: mid.join("|"),
            mmo: "ODDS",
          };

          xhrMatch.get(url, args).then(
            (res) => {
              if (res.success) {

                if (res.data) {
                  var parlay = false;
                  var m = sync2.decode2(
                    res.data,
                    this.menu3,
                    this.commType,
                    this.oddsType,
                    parlay
                  );


                  for (var i = 0; i < mid.length; i++) {
                    var match_id = mid[i];
                    if (!this.odds.hasOwnProperty(match_id)) {
                      this.$set(this.odds, match_id, {});
                    }
                  }

                  var k = {
                    hdp: {},
                    ou: {},
                  };

                  for (var key in m.odds) {
                    var mt = m.odds[key];
                    for (var bt in k) {
                      var m1 = mt[bt];
                      if (m1 == null) {
                      } else {
                        for (var i = 0; i < mid.length; i++) {
                          var m3 = m1[mid[i]];
                          if (m3 == null) {
                          } else {
                            k[bt][mid[i]] = m3;
                          }
                        }
                      }
                    }
                  }


                  for (var bt in k) {
                    var m1 = k[bt];

                    if (m1 == null) {
                      // clear all matches if this bet type not exists
                      for (var i = 0; i < mid.length; i++) {
                        if (this.odds[mid[i]].hasOwnProperty(bt)) {
                          this.$delete(this.odds[mid[i]], bt);
                        }
                      }
                    } else {
                      for (var i = 0; i < mid.length; i++) {
                        var m3 = m1[mid[i]];

                        if (m3 == null) {
                          // clear this match if this bet type not exists
                          if (this.odds[mid[i]].hasOwnProperty(bt)) {
                            this.$delete(this.odds[mid[i]], bt);
                          }
                        } else {
                          for (var m4 in m3) {
                            if (m3[m4][4].toUpperCase() == bt.toUpperCase()) {
                              this.$set(this.odds[mid[i]], bt, m3[m4]);
                              break;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                this.$helpers.handleFeedback(res.status, res.source);
              }
              resolve();
            },
            (err) => {
              this.$helpers.handleFeedback(err.status, err.source);
              resolve();
            }
          );
        } else {
          resolve();
        }
      });
    },
    populateMatches() {
      return new Promise((resolve, reject) => {
        if (![0, 1].includes(this.roomData.room_status)) {
          resolve();
        }

        if (this.matches.length > 0) {
          this.loading.getMatch = true;
          this.$forceUpdate();
          setTimeout(() => {
            this.getMatch(config.getMatchUrl() + "?match=tournament", "tournament", this.matches, "1|2", "hdp|ou", null)
              .then(() => {
                this.loading.getMatch = false;
                resolve();
              })
              .catch((err) => {
                this.loading.getMatch = false;
                console.log(err);
                resolve();
              });
          }, 1000);
        }
      });
    },
    getBetResultList() {
      if ([0, 1].includes(this.roomData.room_status)) {
        return;
      }

      var e = this.roomData.room_id;

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
        target: null,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getBetResultList = true;
      service.betResult(config.tournamentUrl().betresultlist, json).then(
        (result) => {
          this.loading.getBetResultList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.betResultList = result.data.value;
              if (this.betResultList != null && this.betResultList.length > 0) {
                // loop betResultList and sum up the total into betResultListTotal
                this.betResultListTotal = {
                  odds_display: 0,
                  turnover: 0,
                  winlose: 0,
                  payout: 0,
                  status: null,
                };
                for (var i = 0; i < this.betResultList.length; i++) {
                  this.betResultListTotal.turnover += parseFloat(
                    this.betResultList[i].bet_member
                  );
                  this.betResultListTotal.winlose += parseFloat(
                    this.betResultList[i].winlose
                  );
                  this.betResultListTotal.payout += parseFloat(
                    this.betResultList[i].payout
                  );
                }
                if (this.betResultListTotal.winlose > 0) {
                  this.betResultListTotal.status = this.$t("ui.win");
                } else if (this.betResultListTotal.winlose < 0) {
                  this.betResultListTotal.status = this.$t("ui.lose");
                } else {
                  this.betResultListTotal.status = this.$t("ui.draw");
                }
              }
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getBetResultList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getMemberBetList() {
      var e = this.roomData.room_id;

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 1000,
        target: "all",
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getMemberBetList = true;
      service.memberBetList(config.tournamentUrl().memberbetlist, json).then(
        (result) => {
          this.loading.getMemberBetList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              var mbl = result.data.value;
              var mb = {};
              for (var i = 0; i < mbl.length; i++) {
                var ref = mbl[i].ref;
                if (!mb.hasOwnProperty(ref)) {
                  mb[ref] = {
                    member_id: mbl[i].member_id,
                    bet_list: [mbl[i]],
                  };
                } else {
                  mb[ref].bet_list.push(mbl[i]);
                }
              }
              this.participants = mb;
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getMemberBetList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getRoomRank() {
      var e = this.roomData.room_id;

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getRoomRank = true;
      service.roomRank(config.tournamentUrl().roomrank, json).then(
        (result) => {
          this.loading.getRoomRank = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.roomRank = result.data.value;
              this.roomRank.sort((a, b) => {
                return a.top_position - b.top_position;
              });
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getRoomRank = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    getRoomInfo(e) {
      return new Promise((resolve, reject) => {
        var room_id = this.roomId;
        var json = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          room_id: room_id,
        };

        var feedback = {
          success: false,
          status: errors.session.invalidSession,
        };

        // this.roomData = {};
        service.getRoomInfo(config.tournamentUrl().roominfo, json).then(
          (result) => {
            if (result) {
              feedback.success = result.success;
              feedback.status = result.status;
              if (result.success == true) {

                var r = result.data.value[0];
                this.$set(this, "roomData", r);
                EventBus.$emit("ROOM_DATA", r);

                if (e) {
                  if (r.room_join == 1) {
                    if (r.total_points > 0) {
                      this.listMode = 1;
                    }
                  }
                }
              } else {
                this.$helpers.handleFeedback(feedback.status);
              }
              resolve();
            }
          },
          (err) => {
            console.log(err);
            feedback.success = false;
            feedback.status = errors.request.failed;
            this.$helpers.handleFeedback(err.status);
            resolve();
          }
        );
      });
    }
  },
};
</script>
